import { Component, ChangeDetectionStrategy } from '@angular/core'; //changedetectionstrat, inject nur wegen problem in expansion panel hinzugefügt
import { MatDialog, MatDialogModule } from '@angular/material/dialog'; //matdialogmodule nur wegen problem in expansion panel hinzugefügt
import { MatTabsModule } from '@angular/material/tabs';
import { WebsiteConfigFormComponent } from './website-config-form/website-config-form.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';

@Component({
    selector: 'app-website-config',
    standalone: true,
    imports: [
        MatTabsModule,
        MatButtonModule,
        MatIcon,
        MatDialogModule // nur wegen problem in expansion panel hinzugefügt
    ],
    templateUrl: './website-config.component.html',
    styleUrl: './website-config.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush //evtl removen nur für test wegen fehler in expansion panel
})
export class WebsiteConfigComponent {
  
  constructor(private dialog: MatDialog, private websiteState: WebsiteStateService ) { }

  openConfigDialog() {
    this.websiteState.takeSnapshot();
    this.dialog.open(WebsiteConfigFormComponent, {
      panelClass: ['admin-theme', 'dialog-container'],
      width: 'fit-content',
      maxWidth: '80vw',
    });
  }
}